import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { Typography, Grid } from '@material-ui/core';

// STYLES
import { Container, LoaderStyled, Content, SmallerChannelCard, ChannelsGrid } from './styles';

// HELP
import Filter from './Filter';

class Channels extends PureComponent {
  state = {
    channelsData: [],
    filters: {
      package: '',
      addons: [],
    },
  };

  componentDidMount() {
    const { channels, filters } = this.props;

    this.setState({ filters }, () => this.formatChannelsData(channels));
  }

  componentDidUpdate(prevProps, prevState) {
    const { filters: propsFilters, channels } = this.props;
    const { filters: stateFilters } = this.state;

    if (prevProps.filters !== propsFilters) {
      this.setState({ filters: propsFilters }, this.formatChannelsData);

      return;
    }

    if (prevState.filters !== stateFilters) {
      this.setState({ filters: stateFilters }, this.formatChannelsData);
    }

    if (prevProps.channels !== channels) this.formatChannelsData();
  }

  formatChannelsData = () => {
    const { channels } = this.props;
    const { filters } = this.state;
    let channelsData;

    if (filters.package) {
      channelsData = channels.reduce((acc, channel) => {
        const includedServices = channel.services_ids.filter(service => {
          return (
            filters.addons.includes(service.id.toString()) ||
            filters.package === service.id.toString()
          );
        });

        if (includedServices.length) {
          const addons = includedServices.filter(service => service.addon_icon);
          const channelData = {
            id: channel.channel_id,
            name: channel.name,
            imageSrc: channel.icon,
            notAvailable: !channel.in_all_dmas,
            addons,
          };

          acc.push(channelData);
        }

        return acc;
      }, []);
    } else {
      channelsData = channels.map(channel => {
        return {
          id: channel.channel_id,
          name: channel.name,
          imageSrc: channel.icon,
          notAvailable: !channel.in_all_dmas,
          addons: [],
        };
      });
    }

    this.setState({ channelsData });
  };

  setFilters = filters => {
    this.setState({ filters });
  };

  render() {
    const { channelsData, filters } = this.state;
    const { t, appSlug, allIds, loading, handleZipcodeSumbit } = this.props;

    const showFilters = appSlug !== 'frndly-tv';

    return (
      <div id="channels">
        <Container className="page-content">
          <Typography className="title m-b-10" variant="h3" align="center">
            {t('appDetails.channels.title')}
          </Typography>
          <Typography className="p3 subtitle" component="p" variant="inherit" align="center">
            {t('appDetails.channels.subtitle')}
          </Typography>
          {showFilters && (
            <Filter
              filters={filters}
              allIds={allIds}
              setFilters={this.setFilters}
              handleZipcodeSumbit={handleZipcodeSumbit}
              allow_filter={false}
            />
          )}
          <Content>
            <ChannelsGrid container spacing={1}>
              {channelsData.map(item => {
                return (
                  <Grid key={item.id} item xs={3} sm={2} md={1}>
                    <SmallerChannelCard data={item} active hover />
                  </Grid>
                );
              })}
            </ChannelsGrid>
          </Content>
        </Container>
        <LoaderStyled active={loading} />
      </div>
    );
  }
}

Channels.propTypes = {
  t: PropTypes.func.isRequired,
  appSlug: PropTypes.string.isRequired,
  channels: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  filters: PropTypes.object.isRequired,
  packages: PropTypes.array.isRequired,
  addons: PropTypes.array.isRequired,
  allIds: PropTypes.object,
  handleZipcodeSumbit: PropTypes.func.isRequired,
};

export default compose(withTranslation())(Channels);
